import styled, { css, CSSProp } from 'styled-components';
import { colors, typography } from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import { breakpointsMQ4Small } from '../constants';
import IncompleteProfileErrorTag from '../common/IncompleteProfileErrorTag';

interface SubscriberCardStyledProps {
  $isEditable?: boolean;
}

export const SubscriberCardStyled = styled.article<SubscriberCardStyledProps>`
  /* 110rem is the standard content width for the base layout */
  max-width: 110rem;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 3rem;
  padding: 3rem;
  border-radius: 1rem;
  background-color: ${colors.neutral.white};

  ${breakpointsMQ4Small} {
    padding: 2rem 2rem 2rem 1.2rem;
  }

  ${({ $isEditable }): CSSProp =>
    !$isEditable
      ? css`
          padding: 2rem 3rem 4rem;
          border-width: 0;

          ${breakpointsMQ4Small} {
            padding: 2rem;
          }
        `
      : ''}
`;

export const SubscriberHeaderStyled = styled.header<{ $isIncompleteProfile: boolean }>`
  display: flex;
  flex-wrap: wrap;
  gap: 3rem;
  justify-content: space-between;
  padding-bottom: 3rem;
  border-bottom: 0.1rem solid ${colors.neutral[300]};

  ${({ $isIncompleteProfile }): CSSProp =>
    $isIncompleteProfile
      ? css`
          padding-top: 3.5rem;
        `
      : ''}

  ${breakpointsMQ4.lg.down} {
    gap: 2rem;
  }
`;

export const HeaderSectionStyled = styled.div`
  display: flex;
  gap: 5rem;
  justify-content: space-between;
  align-items: flex-start;

  ${breakpointsMQ4.md.down} {
    width: 100%;
    gap: 2rem;
    flex-wrap: wrap;
  }

  ${breakpointsMQ4Small} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const SubscriberNameLabelStyled = styled.span`
  color: ${colors.neutral[800]};
  ${typography.bold[20]}
  /* Adjusted line height to align with the checkbox icon */
  line-height: 2.4rem;
`;

export const IncompleteProfileErrorTagStyled = styled(IncompleteProfileErrorTag)`
  right: 0;
  left: 0;
`;
